// Additional Fields render only the first configured section.
export const mapCustomFields = (sections = []) => sections[0]?.customFields || {}

export const mapCustomFieldValues = (sections = []) => sections[0]?.values || {}
